export function ArrayToStr(arr) {
  return arr && arr.length > 0 ? arr.join(', ') : arr;
}
